import { ErrorType } from 'types';

import { Headline } from 'components/Headline';

import * as S from './Label.styles';

type LabelProps = {
  children: string;
  required?: boolean;
  error?: ErrorType;
};

const defaultProps: Partial<LabelProps> = {
  required: false,
};

export function Label(props: LabelProps): React.ReactElement {
  const { children, required, error } = { ...defaultProps, ...props };

  return (
    <S.Header>
      {children ? <S.Label>{children}</S.Label> : null}

      {required ? (
        <S.Required scale="xs" color="red">
          *
        </S.Required>
      ) : null}

      {error ? (
        <S.ErrorMessage scale="xs" color="red">
          {error.toString()}
        </S.ErrorMessage>
      ) : null}
    </S.Header>
  );
}
